import { ReactNode } from "react";

import { Base } from "@/components/General/Sidebar/components/assortiment/components/categoryLinks/categoryLinks.base";
import { useSidebarContext } from "@/components/General/Sidebar/context/sidebar.context";

type Props = {
    children: ReactNode;
};

export const RootCategory = ({ children }: Props) => {
    const { assortimentOpen } = useSidebarContext();

    if (!assortimentOpen) return null;

    return <Base>{children}</Base>;
};
